import {
  CheckCircle, Warning, XCircle, Question
} from "@phosphor-icons/react";

function StatusIcon({ status }) {
  switch (status) {
    case "good":
      return <CheckCircle size={18} weight="fill" className="text-[#00C853] flex-shrink-0" />;
    case "warning":
      return <Warning size={18} weight="fill" className="text-[#B38F00] flex-shrink-0" />;
    case "bad":
      return <XCircle size={18} weight="fill" className="text-[#FF3B30] flex-shrink-0" />;
    default:
      return <Question size={18} weight="fill" className="text-[--text-muted] flex-shrink-0" />;
  }
}

function ScoreBar({ score, status }) {
  let color;
  if (status === "good") color = "var(--success)";
  else if (status === "warning") color = "var(--warning)";
  else if (status === "bad") color = "var(--danger)";
  else color = "var(--text-muted)";

  return (
    <div className="w-full h-1.5 bg-[--bg-muted] mt-2">
      <div
        className="h-full transition-all duration-500"
        style={{ width: `${score}%`, background: color }}
      />
    </div>
  );
}

export default function AuditScoreChart({ audit }) {
  const checks = audit.checks || {};
  const entries = Object.entries(checks);

  const good = entries.filter(([, c]) => c.status === "good").length;
  const warn = entries.filter(([, c]) => c.status === "warning").length;
  const bad = entries.filter(([, c]) => c.status === "bad").length;

  return (
    <div className="bg-white border border-[--border]" data-testid="audit-score-chart">
      <div className="p-6 border-b border-[--border]">
        <div className="flex items-center justify-between">
          <h3
            className="text-lg font-bold tracking-tight"
            style={{ fontFamily: "'Cabinet Grotesk', sans-serif" }}
          >
            SEO Audit Results
          </h3>
          <div className="flex items-center gap-4 text-xs">
            <span className="flex items-center gap-1">
              <span className="w-2.5 h-2.5 bg-[--success]" /> {good} Passed
            </span>
            <span className="flex items-center gap-1">
              <span className="w-2.5 h-2.5 bg-[--warning]" /> {warn} Warnings
            </span>
            <span className="flex items-center gap-1">
              <span className="w-2.5 h-2.5 bg-[--danger]" /> {bad} Issues
            </span>
          </div>
        </div>
        <p className="text-sm text-[--text-muted] mt-1">{audit.summary}</p>
      </div>

      <div className="divide-y divide-[--border]">
        {entries.map(([key, check]) => (
          <div
            key={key}
            className="p-4 hover:bg-[--bg-hover] transition-colors"
            data-testid={`audit-check-${key}`}
          >
            <div className="flex items-start gap-3">
              <StatusIcon status={check.status} />
              <div className="flex-1">
                <div className="flex items-center justify-between">
                  <h4 className="text-sm font-semibold text-[--text-primary]">
                    {check.label}
                  </h4>
                  <span className="text-xs font-bold text-[--text-muted]">
                    {check.score}/100
                  </span>
                </div>
                <p className="text-xs text-[--text-secondary] mt-1 leading-relaxed">
                  {check.detail}
                </p>
                <ScoreBar score={check.score} status={check.status} />
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
